import type { EnvelopeAccountHoldingsQuery } from './graphql/query.envelopeAccountHoldings.generated';
import type {
  SecurityGroupPosition,
  FinancialSecurity as SecurityHolding,
} from '@betterment/shared-components/src/components/holdings/data';

type ManagedAccount = Extract<EnvelopeAccountHoldingsQuery['envelopeAccount'], { __typename: 'ManagedAccount' }>;

type GqlSecurity = ManagedAccount['securityGroupPositions'][0]['securityPositions'][0]['security'];
type GqlFinancialSecurity = ManagedAccount['securityGroupPositions'][0]['securityPositions'][0]['financialSecurity'];

export function toSecurityHolding(
  gqlSecurity: GqlSecurity,
  gqlFinancialSecurity: GqlFinancialSecurity
): SecurityHolding {
  const { id, symbol, name } = gqlFinancialSecurity;

  if (gqlFinancialSecurity.__typename === 'FinancialSecurityFund' && gqlSecurity.__typename === 'SecurityFund') {
    return { id, symbol, name, url: gqlSecurity.url, expenseRatio: gqlSecurity.expenseRatio.value };
  }

  return { id, symbol, name };
}

export function toSecurityHoldingGroupPositions(
  gqlGroupPositions: ManagedAccount['securityGroupPositions']
): SecurityGroupPosition[] {
  return gqlGroupPositions.map(groupPosition => {
    const positionBySecurityId = new Map(groupPosition.securityPositions.map(sp => [sp.financialSecurity.id, sp]));

    const securityPositions = groupPosition.securityPositionsBySecurity.map(aggregatedPosition => {
      const position = positionBySecurityId.get(aggregatedPosition.financialSecurity.id);
      if (position === undefined)
        throw new Error(
          `No matching securityPosition for financial security id: ${aggregatedPosition.financialSecurity.id}`
        );

      const financialSecurity = toSecurityHolding(position.security, position.financialSecurity);
      return {
        ...aggregatedPosition,
        financialSecurity,
        amount: position.amount,
        shares: position.shares,
      };
    });

    return {
      ...groupPosition,
      securityPositions,
    };
  });
}
